import React from 'react';
import { useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';

import Page from '../../../components/Page/Page';
import SafetyGrid from '../../../components/Home/SafetyGrid/SafetyGrid';
import { HomeProvider } from '../../context/homeContext';

import getAllHomePageSettings from './getAllHomePageSettings.graphql';
import { getDynamicTitleByLocale } from '../../../helpers/getDynamicTitle';
import useQueryResponse from '../../../lib/hooks/useQueryResponse';

import s from './User.css';
function User({ data }) {
  const currentLocale = useSelector((state) => state?.intl?.locale);

  const { loading, data: homePageData } = useQueryResponse({ query: getAllHomePageSettings, fetchPolicy: 'cache-first' });

  const getEditStaticPage = data?.getEditStaticPage;
  const staticLoading = data?.loading;

  let homeSettings = {};
  let dynamicHomePageSettings = [];

  if (!loading && homePageData?.getAllHomePageSettings?.homePageData) {
    homePageData.getAllHomePageSettings.homePageData.forEach((item) => {
      if (Array.isArray(item?.dynamicHomePageSettings)) {
        item.dynamicHomePageSettings.forEach((o) => {
          const newItem = Object.assign({}, o, { name: item?.name });
          dynamicHomePageSettings.push(newItem);
        });
      }
      homeSettings[item.name] = item.value;
    });
  }

  const pageBanner = getEditStaticPage?.result?.pageBanner;

  const dynamicStaticContent = getDynamicTitleByLocale({
    dynamicHomePageSettings: getEditStaticPage?.result?.dynamicStaticContent,
    locale: currentLocale,
  });

  const content = dynamicStaticContent[0]?.content || getEditStaticPage?.result?.content;

  return (
    <>
      {!loading && !staticLoading && (
        <div className='contentPageWrapper'>
          <HomeProvider value={homeSettings}>
            <div className={s.homeBanner} />
            <Page html={content} pageBanner={pageBanner} />
            <div className={s.staticContentPreviewSpace}>
              <SafetyGrid
                dynamicHomePageSettings={dynamicHomePageSettings}
                currentLocale={currentLocale}
              />
            </div>
          </HomeProvider>
        </div>
      )}
    </>
  );
}

export default withStyles(s)(User);
